window.CfonElements = window.CfonElements || {};

CfonElements.prefersReducedMotion = function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

CfonElements.define = function define(name, ctor) {
  if (customElements.get(name)) return;
  customElements.define(name, ctor);
};

CfonElements.Component = class CfonComponent extends HTMLElement {
  connectedCallback() {
    if (this._cfonConnected) return;
    this._cfonConnected = true;
    this.onConnect();
  }

  disconnectedCallback() {
    if (!this._cfonConnected) return;
    this._cfonConnected = false;
    this.onDisconnect();
  }

  onConnect() {}

  onDisconnect() {}

  boolAttr(name, fallback) {
    const value = this.dataset[name];
    if (value === undefined) return Boolean(fallback);
    return value === 'true';
  }

  numAttr(name, fallback) {
    const value = Number(this.dataset[name]);
    return Number.isFinite(value) ? value : fallback;
  }

  jsonAttr(name, fallback) {
    const raw = this.dataset[name];
    if (!raw) return fallback;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return fallback;
    }
  }
};
